module.exports = __webpack_public_path__ + "img/zhucanfuwu_ylfw_zlfw.3f7e0424.png";